import { GridModel } from "common/models/utility-models/list-utility.model";
import { InternshipStudentListModel } from "./internship-student-list.data";

export class InternshipStudentListGridModel extends InternshipStudentListModel {
}

export class InternshipStudentListListingModel extends GridModel<InternshipStudentListGridModel> { }